import React from "react"
import { DckActionCreators, DckSelectors } from "dck-redux"
import * as ItemTypes from "../../redux/items/types"
import FormBusiness from "./Form"
import { connect } from "react-redux"

class UpdateBusiness extends React.Component {

  componentDidMount() {
    const { params, setCurrentBusinessId, loadBusinesses, business } = this.props
    setCurrentBusinessId(params.id)
    if(!business) {
      loadBusinesses()
    }
  }

  render() {
    const { business } = this.props
    return business ? <FormBusiness business={ business } /> : <p>Waiting..</p>
  }
}

const mapDispatchToProps = dispatch => ({
  setCurrentBusinessId: id => dispatch(DckActionCreators.itemMakeActive(ItemTypes.Business, id)),
  loadBusinesses: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.Business)),
})

const mapStateToProps = (state, ownProps) => {
  const business = DckSelectors.selectItemById(state, ItemTypes.Business, ownProps.params.id)
  return { business }
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateBusiness)



// WEBPACK FOOTER //
// ./src/components/Business/UpdateBusiness.js